import React from 'react'
import {getBookingEngineTranslations} from "@assets/js/functions/helpers";

const translations = getBookingEngineTranslations();

// export const loginFormFields = [
//   {
//     key: 'email',
//     value: null,
//     type: 'email',
//     placeholder: translations['placeholder-login-email'],
//     required: true,
//     icon: '/img/icons/icon-envelope.svg',
//   },
//   {
//     key: 'password',
//     value: null,
//     type: 'password',
//     placeholder: translations['placeholder-login-password'],
//     required: true,
//     icon: '/img/icons/icon-key.svg',
//   },
// ]
//
// export const userDataFormFields = [
//   {
//     key: 'firstName',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-firstname'],
//     required: true,
//   },
//   {
//     key: 'lastName',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-lastname'],
//     required: true,
//   },
//   {
//     key: 'tel',
//     value: null,
//     type: 'tel',
//     placeholder: translations['placeholder-phone'],
//     required: true,
//   },
//   {
//     key: 'email',
//     value: null,
//     type: 'email',
//     placeholder: translations['placeholder-email'],
//     required: true,
//   },
//   {
//     key: 'emailConfirm',
//     value: null,
//     type: 'email_confirm',
//     placeholder: translations['placeholder-email-confirm'],
//     required: true,
//   },
//   {
//     key: 'country',
//     value: null,
//     type: 'select',
//     placeholder: translations['placeholder-country'],
//     required: true,
//   },
//   {
//     key: 'street',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-street'],
//     required: true,
//   },
//   {
//     key: 'streetNumber',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-street-nr'],
//     required: true,
//   },
//   {
//     key: 'roomNumber',
//     value: null,
//     type: 'number',
//     placeholder: translations['placeholder-room-nr'],
//     required: false,
//   },
//   {
//     key: 'city',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-city'],
//     required: true,
//   },
//   {
//     key: 'postalCode',
//     value: null,
//     type: 'postal_code',
//     placeholder: translations['placeholder-postalcode'],
//     required: true,
//   },
//   {
//     key: 'comments',
//     value: null,
//     type: 'textarea',
//     placeholder: translations['placeholder-comments'],
//     required: false,
//   },
// ]
//
// export const invoiceDataFormFields = [
//   {
//     key: 'company',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-company'],
//     required: true,
//   },
//   {
//     key: 'nip',
//     value: null,
//     type: 'nip',
//     placeholder: translations['placeholder-company'],
//     required: true,
//   },
//   {
//     key: 'street',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-street'],
//     required: true,
//   },
//   {
//     key: 'streetNumber',
//     value: null,
//     type: 'number',
//     placeholder: translations['placeholder-street-nr'],
//     required: true,
//   },
//   {
//     key: 'roomNumber',
//     value: null,
//     type: 'number',
//     placeholder: translations['placeholder-room-nr'],
//     required: true,
//   },
//   {
//     key: 'city',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-city'],
//     required: true,
//   },
//   {
//     key: 'postalCode',
//     value: null,
//     type: 'text',
//     placeholder: translations['placeholder-postalcode'],
//     required: true,
//   },
// ]

export const CONSENTS = [
  {
    id: 'zgoda_be_vc_wymagana',
    value: 42,
    label: [translations['consents-1-1'],
      <a href={`${location.origin}/regulamin`}
         target='_blank'>{translations['consents-1-2']}</a>,
      `${translations['consents-1-3']}`,
      <a href={`${location.origin}/warunki-rezerwacji`}
         target='_blank'>{translations['consents-1-4']}</a>,
      `${translations['consents-1-5']}`,
      <a href={`${location.origin}`}
         target='_blank'>{`www.${location.host}`}</a>],
  },
  {
    id: 'zgoda_be_vc_wlasne_produkty',
    value: 43,
    label: translations['consents-2-1'],
  },
  {
    id: 'zgoda_be_vc_produkty_uslugi_innych',
    value: 26,
    label: [translations['consents-3-1'],
      <a href={`${location.origin}/regulamin`}
         target='_blank'>{`www.${location.host}/regulamin`}</a>,
      translations['consents-3-2']
    ],
  },
  {
    id: 'zgoda_be_vc_marketing_bezposredni',
    value: 27,
    label: translations['consents-5-1'],
  },
  {
    id: 'zgoda_be_vc_marketing_bezposredni_innych',
    value: 28,
    label: [translations['consents-6-1'],
      <a href={`${location.origin}/regulamin`}
         target='_blank'>{`www.${location.host}/regulamin`}</a>, translations['consents-6-2']],
  },
]

// Dodane 15 czerwca 2022r
export const CONSENTS_2 = {
  'REGULAMINY_1_SM_ID_4435': {
    id: 'REGULAMINY_1_SM_ID_4435',
    value: 54,
    label: [
      translations['i_accept_the'], ` `,
      <a href={translations['regulations-of-services-electronic-href']} target='_blank'>
        {translations['regulations-of-services-electronic-name']}</a>,
      ` `, translations['and'], ` `,
      <a href={translations['privacy-policy-href']} target='_blank'>
        {translations['privacy-policy-name']}</a>,
      `.*`,
    ],
  },
  'ZGODA_2_VC_SM_ID_4437': {
    id: 'ZGODA_2_VC_SM_ID_4437',
    value: 55,
    label: [
      translations['consents-ZGODA_2_VC_SM_ID_4437'],
      `.**`,
    ],
  },
  'ZGODA_1_VC_SM_ID_4436': {
    id: 'ZGODA_1_VC_SM_ID_4436',
    value: 56,
    label: [
      translations['consents-ZGODA_1_VC_SM_ID_4436'],
      `.**`,
    ],
  },
};
